export const REGISTRY_ADDRESS = '0x000000000069E2a187AEFFb852bF3cCdC95151B2';
export const RHINESTONE_ATTESTER_ADDRESS = '0x000000333034E9f539ce08819E12c1b8Cb29084d';
export const MOCK_ATTESTER_ADDRESS = '0xA4C777199658a41688E9488c4EcbD7a2925Cc23A';
//# sourceMappingURL=constants.js.map